import './index.scss';

import imgexport1 from '../../../../../assets/images/para-sua-empresa/produtos-protecao/img-protecao01@2x.png';

export const ImportExport = () => {

    return (
        <div className='container-select-credit'>
            <div className='cont-dados-1'>
                <h1> Travas de importação e exportação </h1>

                <p>
                    Tanto para importação quanto para exportação, existem diversos produtos
                    cambiais que ajudam a "travar" os valores das transações e proteger as
                    empresas das flutuações das moedas. A escolha do produto ideal depende
                    das necessidades específicas de cada empresa, do prazo da operação e da sua
                    tolerância ao risco.
                </p>

                <p style={{ fontWeight: 'bold' }}>
                    Produtos Cambiais para Importação (proteção contra alta da moeda estrangeira):
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}>Contrato de Câmbio a Termo: </span>Permite fixar a taxa de câmbio para uma data futura, garantindo o custo da importação em moeda local. É simples e amplamente utilizado.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}>Swap Cambial: </span>Ideal para operações de longo prazo, permitindo a troca de fluxos de caixa em diferentes moedas e fixando a taxa de câmbio para pagamentos futuros.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}>Opções de Compra (Call): </span>Dão o direito, mas não a obrigação, de comprar a moeda estrangeira a um preço predefinido. Oferecem flexibilidade caso a taxa de câmbio caia, mas têm um custo (prêmio).
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}>NDF (Non-Deliverable Forward): </span>Similar ao contrato a termo, mas usado para moedas com restrições. A liquidação é feita pela diferença entre a taxa acordada e a taxa spot.
                </p>

                <p style={{ fontWeight: 'bold' }}>
                    Produtos Cambiais para Exportação (proteção contra queda da moeda estrangeira):
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}>Contrato de Câmbio a Termo: </span>Permite fixar a taxa de câmbio para uma data futura, garantindo a receita da exportação em moeda local.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}>Swap Cambial: </span>Também útil para exportações de longo prazo, permitindo fixar a taxa de câmbio para recebimentos futuros.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}>Opções de Venda (Put): </span>Dão o direito, mas não a obrigação, de vender a moeda estrangeira a um preço predefinido. Protegem contra quedas bruscas na taxa de câmbio, mas têm um custo (prêmio
                </p>

            </div>
            <div className='cont-dados-2'>
                <img alt={imgexport1} src={imgexport1} />
                <div>
                    <h1> Vantagens </h1>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Previsibilidade de custos de importação: </span>Ao fixar uma
                        taxa de câmbio antecipadamente, a empresa sabe
                        exatamente quanto pagará pela mercadoria em sua moeda
                        local, independentemente das oscilações do mercado
                        cambia, facilitando o planejamento financeiro e
                        orçamentário, permitindo que a empresa projete seus
                        custos com maior precisão.
                    </p>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Proteção contra a desvalorização da moeda local: </span>
                        <br />Se a moeda local se desvalorizar em relação à moeda
                        estrangeira usada na transação de importação, a empresa
                        estará protegida, pois já terá travado o custo na taxa de
                        câmbio acordada.
                    </p>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Maior competitividade: </span>Com custos previsíveis, a empresa
                        pode definir preços de venda com maior segurança, o que a
                        torna mais competitiva no mercado. Sem a incerteza
                        cambial, é possível praticar preços mais agressivos e atrair
                        mais clientes.
                    </p>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Melhora na gestão de fluxo de caixa: </span>A previsibilidade dos
                        custos de importação facilita o planejamento do fluxo de
                        caixa da empresa, permitindo uma gestão financeira mais
                        eficiente. A empresa pode se preparar com antecedência
                        para os pagamentos, evitando surpresas desagradáveis.
                    </p>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Foco no core business: </span>Ao eliminar a preocupação com as
                        flutuações cambiais, a empresa pode se concentrar em
                        suas atividades principais, como produção, vendas e
                        marketing, sem se distrair com a gestão do risco cambial.
                    </p>

                    <div className='buttons-style inv' style={{marginTop:"10px"}}>
                        <a href='https://wa.me/5511973667387' target="_blank" rel="noopener noreferrer" > Fale com um especialista </a>
                    </div>
                </div>
            </div>
        </div>

    )
}

